import { afterNextRender, Component, ElementRef, inject, Injector, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DocumentTypeFilter, DocumentTypeService } from '../../../../../services/document-type.service';
import { IUser } from '../../../../../../@core/models/model';
import { IQnaPair, QNA_SOURCE_TYPE, QnAPairService } from '../../../../../services/qna-pair.service';
import { FORM_QUESTION_STATUS, IContract, IFormAnswer, IFormQuestion } from '../../../../../models/contract-management.model';
import { FormatTextPipe } from '../../../../../../@shared/pipes/formated-text.pipe';
import { ToastService } from '../../../../../../@core/services/toast.service';
import { DynamicComponentRenderer } from '../../../../../../@shared/directives/dynamic-component-renderer.directive';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import _ from 'lodash';
import { DrawerModule } from 'primeng/drawer';
import { IQnaPairMetadata } from '../../../../../models/settings.model';
import { SearchBarComponent } from '../../../../../../@shared/components/search-bar/search-bar.component';
import { DataTableComponent } from '../../../../../../@shared/components/data-table/data-table.component';
import { TableColumn, TableConfig } from '../../../../../../@shared/models/table.models';
import { REVIEW_QNA_TABLE_COLUMNS, REVIEW_QNA_TABLE_CONFIG } from './review-qna-table.config';
import { ButtonComponent } from "../../../../../../@core/components/ui/button/button.component";
import { DialogComponent } from "../../../../../../@core/components/ui/dialog/dialog.component";
import { DialogService } from "../../../../../../@core/services/dialog.service";
import { SelectComponent, SelectOption, SelectConfig } from "../../../../../../@core/components/ui/select";
import { MultiSelectComponent } from "../../../../../../@core/components/ui/multi-select";
import { UserNameDisplayComponent } from 'src/app/@shared/components/user-name-display';

@Component({
    selector: 'app-review-qna',
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        CheckboxModule,
        SelectModule,
        ProgressSpinnerModule,
        FormatTextPipe,
        DynamicComponentRenderer,
        InputGroupModule,
        InputGroupAddonModule,
        DrawerModule,
        SearchBarComponent,
        DataTableComponent,
        ButtonComponent,
        DialogComponent,
        SelectComponent,
        MultiSelectComponent,
        UserNameDisplayComponent
    ],
    standalone: true,
    templateUrl: './review-qna.component.html',
    styleUrl: './review-qna.component.scss'
})
export class ReviewQnaComponent implements OnInit {

    @ViewChild(DataTableComponent) dataTable!: DataTableComponent;

    @ViewChild('questionTemplateRef') questionTemplateRef!: TemplateRef<any>;
    @ViewChild('answerTemplateRef') answerTemplateRef!: TemplateRef<any>;
    @ViewChild('authorTemplateRef') authorTemplateRef!: TemplateRef<any>;
    @ViewChild('dateTemplateRef') dateTemplateRef!: TemplateRef<any>;
    @ViewChild('documentTemplateRef') documentTemplateRef!: TemplateRef<any>;
    @ViewChild('sourceTypeTemplateRef') sourceTypeTemplateRef!: TemplateRef<any>;
    @ViewChildren('qnaCard') qnaCards!: QueryList<ElementRef>;
    private readonly injector = inject(Injector);

    loading: boolean = false;

    selectedItems: string[] = [];
    selectedQnaItems: IQnaPair[] = [];
    isSelectAll: boolean = false;

    selectedDocumentType: string = '';
    documentTypeOptions: SelectOption[] = [];
    documentTypeConfig: SelectConfig = {
        placeholder: 'Select Document Type',
        searchable: true,
        clearable: false,
        styleClass: 'font-semibold rounded-xl text-black border border-gray-200',
        appendTo: 'body'
    };
    qnaLoading: boolean = false;
    qnaData: IQnaPair[] = [];
    totalRecords: number = 0;
    skip: number = 0;
    limit: number = 20;

    tableColumns: TableColumn[] = [...REVIEW_QNA_TABLE_COLUMNS];
    tableConfig: TableConfig = { ...REVIEW_QNA_TABLE_CONFIG };
    searchValue: string = '';
    expandCell: boolean = false;
    expandedCellContent: string = '';
    expandedCellType: string = '';
    requestedQnACount: {
        [key: string]: number;
    } = {};

    showBulkEditDialog: boolean = false

    // Bulk Edit Variables
    editingPairs: (IQnaPair & { question?: string, answer?: string, reviewer?: string })[] = [];
    originalPairs: (IQnaPair & { question?: string, answer?: string, reviewer?: string })[] = [];
    currentEditIndex: number = 0;
    savedPairs: Set<number> = new Set();
    totalEditingCount: number = 0;
    isPreviousDisabled: boolean = true;
    isNextDisabled: boolean = true;
    isSaveDisabled: boolean = true;
    isLoadingMorePairs: boolean = false;
    isSaving: boolean = false;
    editDialogLimit: number = 10;
    editDialogSkip: number = 0;
    userOptions: { label: string; value: string }[] = [];
    isLoadingUsers: boolean = false;
    filterDialog: boolean = false
    filterDocumentNamesRaw: string[] = []
    filterAuthorsRaw: { _id: string, fullName: string }[] = []
    filterSourceTypes: { label: string, value: QNA_SOURCE_TYPE }[] = []
    selectedDocumentNames: string[] = []
    selectedAuthors: string[] = []
    selectedSourceTypes: QNA_SOURCE_TYPE[] = []

    // Transformed filter options for multi-select
    get filterDocumentNames(): { label: string, value: string }[] {
        return this.filterDocumentNamesRaw.map(name => ({ label: name, value: name }));
    }

    get filterAuthors(): { label: string, value: string }[] {
        return this.filterAuthorsRaw.map(author => ({ label: author.fullName, value: author._id }));
    }


    constructor(
        private documentTypeService: DocumentTypeService,
        private qnaPairService: QnAPairService,
        private toast: ToastService,
        private dialogService: DialogService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.skip = 0;
        this.getDocTypesWithForm();
        this.getFilterOptions();
    }



    get templatesMap(): { [key: string]: TemplateRef<any> } {
        return {
            'questionTemplate': this.questionTemplateRef,
            'answerTemplate': this.answerTemplateRef,
            'authorTemplate': this.authorTemplateRef,
            'dateTemplate': this.dateTemplateRef,
            'documentTemplate': this.documentTemplateRef,
            'sourceTypeTemplate': this.sourceTypeTemplateRef
        };
    }

    get tableConfigWithHeight(): TableConfig {
        return {
            ...this.tableConfig,
            scrollable: true,
            scrollHeight: 'flex'
        };
    }

    getDocTypesWithForm() {
        this.documentTypeService.getDocTypes([DocumentTypeFilter.FORM_RELATED]).subscribe(res => {
            if (res && res.success) {
                this.documentTypeOptions = res.data.map((doc) => {
                    return {
                        label: doc.name,
                        value: doc._id
                    }
                });

                this.route.queryParamMap.subscribe(params => {
                    const documentTypeId = params.get('documentTypeId');
                    if (documentTypeId) {
                        const optionExists = this.documentTypeOptions.some(option => option.value === documentTypeId);
                        if (optionExists) {
                            this.selectedDocumentType = documentTypeId;
                        } else {
                            this.selectedDocumentType = this.documentTypeOptions?.[0]?.value ?? '';
                        }
                    } else {
                        this.selectedDocumentType = this.documentTypeOptions?.[0]?.value ?? '';
                    }
                    this.getQnAPairs(20);
                });
            }
        })
    }

    getQnAPairs(limit: number = this.limit, append: boolean = false) {
        this.tableConfig = { ...this.tableConfig, loading: true };
        const data = {
            documentTypeId: this.selectedDocumentType,
            searchValue: this.searchValue,
            skip: this.skip,
            limit: limit,
            filter: {
                status: [FORM_QUESTION_STATUS.REQUESTED],
                author: this.selectedAuthors,
                documentName: this.selectedDocumentNames,
                sourceType: this.selectedSourceTypes
            }
        }
        this.qnaPairService.getQnAPairs(data).subscribe((res) => {
            this.tableConfig = { ...this.tableConfig, loading: false };
            if (res.success) {
                if (append) {
                    this.qnaData.push(...res.data.data);
                } else {
                    this.qnaData = res.data.data;
                }
                this.totalRecords = res.data.totalRecords;
            }
        });
    }

    getFilterOptions() {
        this.qnaPairService.getQnAReviewFilterOptions().subscribe((res) => {
            if (res.success) {
                this.filterDocumentNamesRaw = res.data.documentName
                this.filterAuthorsRaw = res.data.author
                this.filterSourceTypes = res.data.sourceType
            }
        })
    }

    bulkStatusUpdate(status: FORM_QUESTION_STATUS, questionIds: string[]) {
        this.qnaPairService.bulkStatusUpdatesQnAPairs(
            '',
            questionIds,
            status,
            this.selectedDocumentType
        ).subscribe((res) => {
            if (res.success) {
                if (status === FORM_QUESTION_STATUS.APPROVED) {
                    this.toast.success('New Q&A added in Q/a Pair successfully.');
                } else if (status === FORM_QUESTION_STATUS.REJECTED) {
                    this.toast.success('Q&A pair rejected successfully.');
                }
                this.selectedItems = [];
                this.selectedQnaItems = [];
                this.isSelectAll = false;
                this.skip = 0;
                this.dataTable?.clearSelection();
                this.getQnAPairs();
            }
        });
    }

    selectDocumentType(documentType: string): void {
        this.selectedDocumentType = documentType;
        this.selectedItems = [];
        this.selectedQnaItems = [];
        this.isSelectAll = false;
        this.skip = 0;
        this.dataTable?.clearSelection();
        this.getQnAPairs();
    }

    getDocumentTypeCount(documentType: string): number {
        return this.requestedQnACount[documentType] || 0;
    }

    toggleSelectAll(event: any): void {
        if (event.checked) {
            this.selectedItems = this.qnaData.map(item => (item.question as IFormQuestion)._id);
            this.selectedQnaItems = [...this.qnaData];
            this.isSelectAll = true;
        } else {
            this.selectedItems = [];
            this.selectedQnaItems = [];
            this.isSelectAll = false;
        }
    }

    get selectAllChecked(): boolean {
        return this.isSelectAll || (this.selectedItems.length > 0 && this.selectedItems.length === this.qnaData.length);
    }

    isSelected(qna: IQnaPair): boolean {
        return this.selectedItems.includes((qna.question as IFormQuestion)._id);
    }

    getQuestionTitle(qna: IQnaPair): string {
        if (typeof qna.question === 'string') {
            return qna.question;
        }
        return (qna.question as IFormQuestion)?.title || '';
    }

    getAnswerValue(qna: IQnaPair): string {
        if (typeof qna.answer === 'string') {
            return qna.answer;
        }
        return (qna.answer as IFormAnswer)?.value || '';
    }

    getAuthorName(qna: IQnaPair): string {
        if (typeof qna.author === 'string') {
            return qna.author;
        }
        return (qna.author as IUser)?.fullName || '';
    }

    toggleRowSelection(item: IQnaPair, event: any): void {
        const questionId = (item.question as IFormQuestion)._id;
        if (event.checked) {
            if (!this.selectedItems.includes(questionId)) {
                this.selectedItems.push(questionId);
            }
        } else {
            this.selectedItems = this.selectedItems.filter(id => id !== questionId);
            this.isSelectAll = false;
        }

        if (this.selectedItems.length === this.qnaData.length && this.qnaData.length < this.totalRecords) {
            this.isSelectAll = true;
        } else if (this.selectedItems.length < this.qnaData.length) {
            this.isSelectAll = false;
        }
    }

    onDocumentTypeChange(): void {
        this.getQnAPairs();
    }

    approveItem(item: IQnaPair): void {
        const questionId = (item.question as IFormQuestion)._id;
        this.bulkStatusUpdate(FORM_QUESTION_STATUS.APPROVED, [questionId]);
    }

    rejectItem(item: IQnaPair): void {
        const questionId = (item.question as IFormQuestion)._id;
        this.bulkStatusUpdate(FORM_QUESTION_STATUS.REJECTED, [questionId]);
    }

    bulkApprove() {
        this.bulkStatusUpdate(FORM_QUESTION_STATUS.APPROVED, this.selectedItems);
    }

    bulkReject() {
        this.bulkStatusUpdate(FORM_QUESTION_STATUS.REJECTED, this.selectedItems);
    }

    openModel(answer: string, type: string) {
        this.expandCell = !this.expandCell;
        this.expandedCellContent = answer;
        this.expandedCellType = type;
        if (!this.expandCell) {
            this.expandedCellContent = '';
        }
    }

    getRowClass = (rowData: any, index: number): string => {
        const questionId = (rowData.question as IFormQuestion)._id;
        return this.selectedItems.includes(questionId) ? 'bg-orange-100' : '';
    }

    onSelectionChange(selection: any[]) {
        this.selectedQnaItems = selection;
        this.selectedItems = selection.map(item => (item.question as IFormQuestion)._id);
    }

    getLastEdited(qna: IQnaPair): string {
        return (qna as any).lastEdited || '-';
    }

    getDocumentName(qna: IQnaPair): string {
        if (typeof qna.document === 'string') {
            return qna.document;
        }
        const contractName = (qna.document as any)?.name;
        if (contractName) return contractName;

        const metadata: any = typeof qna.metadata === 'string' ? null : qna.metadata;
        return (
            metadata?.attachment?.filename ||
            metadata?.upload?.attachment?.filename ||
            '-'
        );
    }

    getSourceType(qna: IQnaPair): string {
        if (!qna.sourceType) return '-';
        return qna.sourceType.charAt(0).toUpperCase() + qna.sourceType.slice(1).toLowerCase();
    }

    onScroll() {
        if (this.tableConfig.loading || this.qnaData.length >= this.totalRecords) {
            return;
        }
        this.skip += this.limit;
        this.getQnAPairs(this.limit, true);
    }

    onPageChange(event: any) {
        this.skip = event.first;
        this.limit = event.rows;
        this.getQnAPairs();
    }

    searchQna = _.debounce(() => {
        this.skip = 0;
        this.selectedItems = [];
        this.selectedQnaItems = [];
        this.isSelectAll = false;
        this.dataTable?.clearSelection();
        this.getQnAPairs();
    }, 300);

    onSearch() {
        this.searchQna();
    }

    onBulkEdit() {
        const selectedItemsSet = new Set(this.selectedItems)
        const selectedIds = this.qnaData.filter(_ => selectedItemsSet.has((_.question as IFormQuestion)._id)).map(_ => _._id);
        if (selectedIds.length === 0) {
            this.toast.error("Please select at least one QnA pair to edit");
            return;
        }
        this.qnaPairService.getQnAPairs({
            documentTypeId: this.selectedDocumentType,
            searchValue: this.searchValue,
            ids: selectedIds,
            skip: this.editDialogSkip,
            limit: selectedIds.length,
            filter: { status: [FORM_QUESTION_STATUS.REQUESTED] }
        }).subscribe((res) => {
            if (res.success) {
                this.editingPairs = res.data.data.map(pair => ({
                    ...pair,
                    question: (pair.question as IFormQuestion).title,
                    answer: (pair.answer as IFormAnswer).value,
                    reviewer: pair.reviewers && pair.reviewers.length > 0 ? pair.reviewers[0]._id : undefined
                }));
                this.originalPairs = this.editingPairs.map(pair => ({ ...pair }));
                this.currentEditIndex = 0;
                this.showBulkEditDialog = true;
                this.totalEditingCount = this.editingPairs.length;
                this.isPreviousDisabled = true;
                this.isNextDisabled = this.editingPairs.length < 1;
            } else {
                this.toast.error("Failed to load QnA pairs");
            }
        });
    }

    savePair(index: number) {
        if (
            this.originalPairs[index].question === this.editingPairs[index].question &&
            this.originalPairs[index].answer === this.editingPairs[index].answer &&
            this.originalPairs[index].reviewer === this.editingPairs[index].reviewer
        ) {
            this.savedPairs.delete(index);
        } else {
            this.savedPairs.add(index);
        }
        this.isSaveDisabled = this.savedPairs.size === 0;
    }

    onSaveBulkEdit(checkComplete: boolean = true) {
        const modifiedPairs = Array.from(this.savedPairs).map(index => {
            const pair = this.editingPairs[index];
            return {
                id: pair._id,
                question: pair.question || '',
                answer: pair.answer || '',
                reviewer: pair.reviewer || ''
            };
        });
        if (checkComplete && modifiedPairs.length !== this.editingPairs.length) {
            this.saveIncompletePairs()
            return;
        }
        this.isSaving = true;
        this.qnaPairService.bulkUpdateQnaPairs(modifiedPairs).subscribe({
            next: (res) => {
                this.isSaving = false;
                if (res.success) {
                    this.toast.success(`${modifiedPairs.length} QnA pairs updated successfully`);
                    this.showBulkEditDialog = false;
                    this.skip = 0;
                    this.getQnAPairs();
                    this.onCancelBulkEdit();
                }
            },
            error: () => {
                this.isSaving = false;
                this.toast.error("Failed to update QnA pairs");
            }
        });
    }

    saveIncompletePairs() {
        this.dialogService.confirm({
            title: 'Save Incomplete Q&A Pair?',
            description: 'You can save progress, but incomplete data may affect performance. Continue?',
            confirmText: 'Yes, Continue',
            cancelText: 'Complete Q&A First',
        }).subscribe(confirmed => {
            if (confirmed) {
                this.onSaveBulkEdit(false);
            }
        });
    }


    onCancelBulkEdit() {
        this.showBulkEditDialog = false;
        this.editingPairs = [];
        this.currentEditIndex = 0;
        this.resetEditDialog();
        this.isPreviousDisabled = true;
        this.editDialogSkip = 0
        this.editDialogLimit = 10
        this.selectedItems = [];
        this.selectedQnaItems = [];
        this.isSelectAll = false;
        this.dataTable?.clearSelection();
    }

    selectQnaPair(index: number) {
        this.currentEditIndex = index;
        this.scrollToActiveCard();
    }

    navigatePrevious() {
        if (this.currentEditIndex > 0) {
            this.currentEditIndex--;
        }
        this.isPreviousDisabled = this.currentEditIndex === 0;
        this.isNextDisabled = this.currentEditIndex === this.editingPairs.length - 1;
        this.scrollToActiveCard();
    }

    navigateNext() {
        if (this.currentEditIndex < this.editingPairs.length - 1) {
            this.currentEditIndex++;
        }
        this.isPreviousDisabled = this.currentEditIndex === 0;
        this.isNextDisabled = this.currentEditIndex === this.editingPairs.length - 1;
        this.scrollToActiveCard();
    }

    scrollToActiveCard() {
        afterNextRender(() => {
            const cards = this.qnaCards.toArray();
            cards[this.currentEditIndex]?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, { injector: this.injector });
    }

    resetEditDialog() {
        this.totalEditingCount = 0;
        this.isPreviousDisabled = true;
        this.isNextDisabled = true;
        this.isSaveDisabled = true;
        this.savedPairs.clear();
    }

    openFilterDialog() {
        this.filterDialog = true;
    }

    applyFilter() {
        this.filterDialog = false;
        this.skip = 0;
        this.selectedItems = [];
        this.selectedQnaItems = [];
        this.isSelectAll = false;
        this.dataTable?.clearSelection();
        this.getQnAPairs();
    }

    clearFilter() {
        this.selectedDocumentNames = []
        this.selectedAuthors = []
        this.selectedSourceTypes = []
        this.filterDialog = false;
        this.skip = 0;
        this.selectedItems = [];
        this.selectedQnaItems = [];
        this.isSelectAll = false;
        this.dataTable?.clearSelection();
        this.getQnAPairs();
    }

} 
